<template>
  <v-container fluid class="pa-0">
    <!-- Navegación izquierda -->
    <v-navigation-drawer
      v-model="sidenav"
      app
      fixed
      mobile-breakpoint="960"
      class="step-2 dashboard-navbar-drawer"
    >
      <v-list nav dense>
        <v-list-item class="d-flex flex-column justify-center py-5 mt-14">
          <v-img
            v-if="organizationLogo"
            :src="organizationLogo"
            class="rounded-pill"
            max-width="150"
          ></v-img>
          <v-img
            v-else
            src="@/assets/images/weChamber/logo-WC-microsite-2.svg"
            max-width="150"
            contain
          ></v-img>
          <span v-if="adminLabel" class="admin-role-label">
            <v-icon
              size="13"
              class="admin-role-label__icon"
              :style="{ color: adminLabelColor }"
              aria-hidden="true"
            >mdi-shield-check</v-icon>
            <span>{{ adminLabel }}</span>
          </span>
        </v-list-item>
        <div
          v-if="isDevEnvironment"
          class="mx-3 my-2"
          style="
            background-color: #ffb500;
            color: #1b273e;
            border-radius: 8px;
            padding: 5px 10px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.5px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <v-icon small style="color: #000000; vertical-align: middle;">mdi-alert</v-icon>
          Entorno dev
        </div>
        <!--<v-list-item v-if="$vuetify.breakpoint.mdAndDown">
          <v-img src="@/assets/images/weChamber/logo-WC.png"></v-img>
        </v-list-item>-->
      </v-list>
      <v-list nav rounded dense>
        <v-list-item-group v-model="item">
          <template v-if="user.role === 'ORGANIZATION'">
            <div v-for="(item, i) in permissionsNav" :key="i" class="mx-4">
              <v-list-item
                v-if="!item.disabled"
                :to="item.external ? undefined : item.link"
                :href="item.external ? item.link : undefined"
                :target="item.external ? '_blank' : undefined"
                :rel="item.external ? 'noopener noreferrer' : undefined"
                class="ml-4"
                active-class="white--text wDarkerBlue "
              >
                <v-list-item-icon class="px-2 d-flex justify-center">
                  <span
                    v-if="item.iconImage"
                    class="asocoins-sidebar-icon"
                    aria-hidden="true"
                    :style="{ maskImage: `url(${item.iconImage})`, WebkitMaskImage: `url(${item.iconImage})` }"
                  ></span>
                  <v-icon v-else>{{ item.icon }}</v-icon>
                  <!-- <v-badge
                    v-show="item.badge"
                    color="transparent"
                    overlap
                    dark
                    offset-y="20"
                  >
                    <template v-slot:badge>
                      <v-icon color="red lighten-2" size="20">
                        mdi-star mdi-spin
                      </v-icon>
                    </template>
                  </v-badge> -->
                </v-list-item-icon>
                <v-list-item-title
                  >{{ item.title }}
                  <p
                    v-if="item.disabled"
                    class="caption secondary--text font-weight-bold mb-0"
                  >
                    Próximamente
                  </p>
                </v-list-item-title>
                <!--<v-badge
                v-show="item.disabled"
                color="transparent"
                :offset-x="$vuetify.breakpoint.mdAndUp?'70':'40'"
                offset-y="8"
              >
                <template v-slot:badge>
                  <p class="caption secondary--text font-weight-bold mb-0">Pronto...</p>
                </template>  
              </v-badge>-->
                <!--<v-badge
                v-show="item.disabled"
                color="transparent"
                overlap
                dark
                offset-y="20"
              >
                <template v-slot:badge>
                  <p class="secondary--text">Próximamente</p>
                </template>  
              </v-badge>-->
              </v-list-item>
            </div>
          </template>

          <div v-else>
            <div v-for="(item, i) in permissionsNav" :key="i">
              <v-list-item
                v-if="!item.disabled"
                :to="item.external ? undefined : item.link"
                :href="item.external ? item.link : undefined"
                :target="item.external ? '_blank' : undefined"
                :rel="item.external ? 'noopener noreferrer' : undefined"
                class="d-flex justify-center py-0"
                active-class="white--text wDarkerBlue font-weight-800"
              >
                <v-list-item-icon class="d-flex justify-center mx-4 py-0">
                  <span
                    v-if="item.iconImage"
                    class="asocoins-sidebar-icon"
                    aria-hidden="true"
                    :style="{ maskImage: `url(${item.iconImage})`, WebkitMaskImage: `url(${item.iconImage})` }"
                  ></span>
                  <v-icon v-else>{{ item.icon }}</v-icon>
                  <!-- <v-badge
                    v-show="item.badge"
                    color="transparent"
                    overlap
                    dark
                    offset-y="20"
                  >
                    <template v-slot:badge>
                      <v-icon color="red lighten-2" size="20">
                        mdi-star mdi-spin
                      </v-icon>
                    </template>
                  </v-badge> -->
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }} </v-list-item-title>
                <!--<v-badge
                v-show="item.disabled"
                color="transparent"
                :offset-x="$vuetify.breakpoint.mdAndUp?'70':'40'"
                offset-y="8"
              >
                <template v-slot:badge>
                  <p class="caption secondary--text font-weight-bold mb-0">Pronto...</p>
                </template>  
              </v-badge>-->
                <!--<v-badge
                v-show="item.disabled"
                color="transparent"
                overlap
                dark
                offset-y="20"
              >
                <template v-slot:badge>
                  <p class="secondary--text">Próximamente</p>
                </template>  
              </v-badge>-->
              </v-list-item>
            </div>
          </div>

          <v-list-item
            v-if="$vuetify.breakpoint.smAndDown"
            to="/escanear-qr"
            class="d-flex justify-center"
            active-class="white--text wDarkerBlue"
          >
            <v-list-item-icon class="mx-4">
              <v-icon>mdi-qrcode-scan</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Escanear código QR </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$vuetify.breakpoint.smAndDown"
            class="px-6 px-md-2 red darken-4"
            @click="logOutDialog = true"
          >
            <v-list-item-icon>
              <v-icon color="white">mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="white--text font-weight-bold"
              >Cerrar sesión</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- / Navegación izquierda -->
    <!-- Menú derecho -->
    <v-col cols="12" class="d-flex justify-end mb-5">
      <!--<v-list-item>
        <p>Evento perrón dadsadasd das  sad  dd asd asddsa </p>
      </v-list-item>-->
      <!--<v-list-item-icon v-if="$vuetify.breakpoint.mdAndDown">
        <v-img
          max-height="40"
          max-width="40"
          src="@/assets/images/weChamber/logo-WC.png"
        ></v-img>
      </v-list-item-icon>-->
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown"
        class="mx-2"
        color="primary"
        icon
        large
        @click="sidenav = true"
      >
        <v-icon> mdi-menu </v-icon>
      </v-btn>

      <!-- <OrganizerBalance :classes="['rounded-container']" :user="user" /> -->

      <div>
        <AccountMenu @logOut="closeLogOutDialog"></AccountMenu>
        <!--  -->
      </div>
    </v-col>
    <PersonalizedDialog
      :dialog="logOutDialog"
      @save="_logout"
      @discard="logOutDialog = false"
    >
      <template v-slot:alertContent>
        <p class="title text-center">¿Está seguro que desea cerrar sesión?</p>
      </template>
    </PersonalizedDialog>
    <!-- / Menú derecho -->
  </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { isImefOrganization } from "@/share/imef";
import ActionButton from "@/components/shared/ActionButton";
import OrganizerBalance from "./OrganizerBalance";
import AccountMenu from "./AccountMenu.vue";
import Endpoints from "@/share/Endpoints";
import PersonalizedDialog from "../../../components/shared/PersonalizedDialog";
import asocoinsSidebarIcon from "@/assets/images/asocoins/coin-clatter-svgrepo-com.svg";
import {
  canAccessProductServices,
  canAccessVoting,
  canManageAsocoins,
  isAsocoinsRouteEnabled,
  getSpecialOrganizationPermission,
} from "@/common/featureAccess";
import {
  getOrganizationId,
  hasOrganizationChapters,
  isAmpiOrganizationUser,
} from "@/common/ampiOrganizationUserAccess";

const votingAppUrl = (
  process.env.VUE_APP_VOTING_URL || "http://localhost:5174"
).replace(/\/$/, "");

export default {
  components: {
    ActionButton,
    OrganizerBalance,
    PersonalizedDialog,
    AccountMenu,
  },
  data() {
    return {
      sidenav: false,
      bottomNav: 0,
      item: 1,
      logOutDialog: false,
      menuContentElevation: 0,
      drawer: false,
      tabs: [
        { title: "Editar mis datos", icon: "mdi-account-edit-outline" },
        { title: "Cerrar sesión", icon: "mdi-logout-variant" },
      ],
      navigations: [],
      chapterMembershipSalesEnabled: false,
      roleNavigations: [
        {
          icon: "mdi-view-dashboard-outline",
          title: "Panel de inicio",
          link: "/panel-inicio",
          disabled: true,
        },
        {
          icon: "mdi-badge-account-horizontal-outline",
          title: "Mis Miembros",
          link: "/miembros",
          disabled: true,
        },
        {
          icon: "mdi-calendar-outline",
          title: "Mis eventos",
          link: "/mis-eventos",
          disabled: true,
        },
        {
          icon: "mdi-shopping-outline",
          title: "Mis Productos y Servicios",
          link: "/mis-productos",
          disabled: false,
        },
        {
          icon: "mdi-store-outline",
          title: "Mis Capítulos",
          link: "/capitulos",
          disabled: true,
        },
        {
          icon: "mdi-credit-card-settings-outline",
          title: "Ventas de membresías",
          link: "/mi-capitulo/ventas-membresias",
          disabled: true,
          chapterMembershipSalesOnly: true,
        },
        {
          icon: "mdi-wallet-outline",
          title: "Mis Ingresos", //dispersiones
          link: "/dispersiones",
          disabled: true,
        },
        {
          icon: "mdi-radio",
          title: "Mi Comunidad", //Community
          link: "/mi-comunidad",
          disabled: false,
        },
        {
          icon: "mdi-chart-bar",
          title: "Data Center",
          link: "/graphs-ampi",
          disabled: false,
        },
        {
          icon: "mdi-hand-coin-outline",
          title: "Mis Beneficios",
          link: "/mis-beneficios",
          disabled: false,
        },
        {
          icon: "mdi-school",
          title: "Academia",
          link: process.env.VUE_APP_ACADEMY_URL || "",
          disabled: false,
          external: true,
          devOnly: true,
        },
        {
          icon: "mdi-vote-outline",
          title: "Votaciones",
          link: `${votingAppUrl}/admin`,
          disabled: false,
          external: true,
          prodAsofomOnly: true,
        },
        {
          icon: "mdi-alpha-s-circle-outline",
          title: "Stripe",
          link: "/embedded",
          disabled: false,
        },
         {
           icon: "mdi-account-group",
           title: "Subgrupos",
          link: "/subgrupos",
          disabled: false,
         },
         {
           icon: "mdi-file-document-multiple-outline",
           title: "Reportes",
          link: "/reports",
          disabled: false,
         },
        {
          icon: "mdi-file-document-outline",
          title: "Mis Facturas",
          link: "/mis-facturas",
          disabled: true,
        },
        {
          icon: "mdi-shield-search",
          title: "Auditoría",
          link: "/audit-logs",
          disabled: true,
        },
        {
          icon: "mdi-chart-box-outline",
          title: "Analíticas de uso",
          link: "/analiticas-uso",
          disabled: true,
        },
        {
          icon: "mdi-clipboard-pulse-outline",
          title: "Autodiagnóstico SAC",
          link: "/sac/admin",
          disabled: true,
          devOnly: true,
        },
        {
          icon: "mdi-coins",
          iconImage: asocoinsSidebarIcon,
          title: "Administración Asocoins",
          link: "/asocoins/admin",
          disabled: false,
          managerOnly: true,
        },
      ],
    };
  },
  computed: {
    ...mapState("user", ["user", "organizationProfilePicture"]),
    isDevEnvironment() {
      return process.env.VUE_APP_ENVIRONMENT === 'development';
    },
    chapterOrRegionText() {
      return this.user._id === '696fe6b02268d27aba1d58e6' ? 'Región' : 'Capítulo';
    },
    chapterOrRegionTextPlural() {
      return this.user._id === '696fe6b02268d27aba1d58e6' ? 'Regiones' : 'Capítulos';
    },
    organizationLogo() {
      if (this.user && this.user.role === 'ORGANIZATION_USER') {
        const organizationPicture = this.organizationProfilePicture;
        return organizationPicture &&
          organizationPicture !== 'NOT_ASSIGNED' &&
          organizationPicture !== 'N/D'
          ? organizationPicture
          : null;
      }

      const organization = this.user && this.user.organization;
      const organizationLogo = organization && typeof organization === 'object'
        ? organization.profilePicture || organization.logo
        : null;
      const headOffice = this.user && this.user.headOffice;
      const headOfficeLogo = headOffice && typeof headOffice === 'object'
        ? headOffice.profilePicture || headOffice.logo
        : null;
      const userLogo = this.user && this.user.profilePicture;
      const logo = organizationLogo || headOfficeLogo || userLogo;

      return logo && logo !== 'NOT_ASSIGNED' && logo !== 'N/D' ? logo : null;
    },
    adminLabel() {
      if (!this.user) return null;
      if (this.user.role === 'ORGANIZATION_USER') {
        const specialPermission = getSpecialOrganizationPermission(this.user);
        if (specialPermission === 'ASOCOINS_ONLY') return 'Solo Asocoins';
        if (specialPermission === 'COMMITTEE_MANAGER') return 'Gerentes de Comité';
        return this.user.permissionsType === 'TOTAL_ACCESS'
          ? 'Admin con acceso total'
          : 'Admin con permiso asignado';
      }
      if (['ORGANIZATION', 'HEAD_OFFICE'].includes(this.user.role)) {
        return 'Admin principal';
      }
      return null;
    },
    adminLabelColor() {
      return this.user && this.user.role === 'ORGANIZATION_USER'
        ? '#f2b705'
        : '#2e7d32';
    },
    permissionsNav() {
      let nav = this.roleNavigations.map((item) => ({ ...item }));
      const specialPermission = getSpecialOrganizationPermission(this.user);
      if (specialPermission) {
        const allowedLinks = specialPermission === 'COMMITTEE_MANAGER'
          ? ['/asocoins/admin', '/mi-comunidad', '/mis-eventos', '/miembros']
          : ['/asocoins/admin'];
        return nav
          .filter((item) => allowedLinks.includes(item.link))
          .map((item) => ({ ...item, disabled: false }));
      }

      const isAmpiFullAccess = isAmpiOrganizationUser(this.user);
      const organizationHasChapters = hasOrganizationChapters(this.user);
      const findIndexOfRoutes = (linkArray, link) => {
        return [...linkArray].findIndex((element) => element.link === link);
      };
      if (this.user.role !== 'BRANCH') {
        nav = nav.filter((item) => !item.chapterMembershipSalesOnly);
      } else if (this.chapterMembershipSalesEnabled) {
        const chapterSalesIndex = findIndexOfRoutes(
          nav,
          '/mi-capitulo/ventas-membresias',
        );
        if (chapterSalesIndex !== -1) nav[chapterSalesIndex].disabled = false;
      }
      if (this.user.role === 'ASOCOINS_MANAGER') {
        return isAsocoinsRouteEnabled()
          ? nav.filter((item) => item.managerOnly)
          : [];
      }
      if (!isAsocoinsRouteEnabled() || !canManageAsocoins(this.user)) {
        nav = nav.filter((item) => !item.managerOnly);
      }

      const organizationId = getOrganizationId(this.user);
      const isImef = isImefOrganization(this.user._id, organizationId);

      if (isImef) {
        nav = nav.filter((item) => item.link !== '/mis-facturas');
      }

      if (this.user.permissions.Membership && !isAmpiFullAccess) {
        let {create, read, update} = this.user.permissions.Membership;
        if ([create, read, update].some(element => element === false)) {
          nav[findIndexOfRoutes(nav, '/mis-beneficios')].disabled = true
        }
      }

      // ocultar data center y stripe de organizaciones diferentes a ampi
      if (!isAmpiFullAccess && this.user._id != "6297b0fec7bf8b6f826313be") {
        nav[findIndexOfRoutes(nav, '/embedded')].disabled = true;
        nav[findIndexOfRoutes(nav, '/graphs-ampi')].disabled = true;
      }

      if(this.user._id != '66fb2d896646ca001cb93b3f' && organizationId != '66fb2d896646ca001cb93b3f') {
        nav[findIndexOfRoutes(nav, '/reports')].disabled = true;
      }

      if (this.user.permissions.Panel && this.user.permissions.Panel.read) {
        nav[findIndexOfRoutes(nav, '/panel-inicio')].disabled = false;
      }
      if (this.user.permissions.Event && this.user.permissions.Event.read) {
        nav[findIndexOfRoutes(nav, '/mis-eventos')].disabled = false;
      }
      if ([ "HEAD_OFFICE", "BRANCH", "ORGANIZATION_USER" ].includes(this.user.role)) {
        const { Members: { read: memberRead = false }, Chapters: { read: chapterRead = false } } = this.user?.permissions || {};

        if ( memberRead ) {
          nav[findIndexOfRoutes(nav, '/miembros')].disabled = false;
        }
        if ( chapterRead && organizationHasChapters ) {
          nav[findIndexOfRoutes(nav, '/capitulos')].disabled = false;
        }
      }
      if (
        this.user.permissions.Dispersions &&
        this.user.permissions.Dispersions.read
      ) {
        nav[findIndexOfRoutes(nav, '/dispersiones')].disabled = false;
      }

      if (!organizationHasChapters) {
        nav[findIndexOfRoutes(nav, '/capitulos')].disabled = true;
      }

      // Mantener Mis Facturas para organizaciones no IMEF con acceso existente
      if (
        !isImef &&
        (
          this.user.role === 'ORGANIZATION' ||
          this.user.role === 'HEAD_OFFICE' ||
          isAmpiFullAccess ||
          (this.user.permissions.Invoice && this.user.permissions.Invoice.read)
        )
      ) {
        const invoicesIndex = findIndexOfRoutes(nav, '/mis-facturas');
        if (invoicesIndex !== -1) {
          nav[invoicesIndex].disabled = false;
        }
      }

      // Habilitar Auditoría para ORGANIZATION y HEAD_OFFICE
      if (
        this.user.role === 'ORGANIZATION' ||
        this.user.role === 'HEAD_OFFICE' ||
        isAmpiFullAccess ||
        (this.user.permissions.AuditLog && this.user.permissions.AuditLog.read)
      ) {
        nav[findIndexOfRoutes(nav, '/audit-logs')].disabled = false;
      }

      const memberAnalyticsIndex = findIndexOfRoutes(nav, '/analiticas-uso');
      if (memberAnalyticsIndex !== -1) {
        nav[memberAnalyticsIndex].disabled = !['HEAD_OFFICE', 'ORGANIZATION'].includes(this.user.role);
      }

      // Habilitar SAC sólo para admins de ASOFOM (ID 696fe6b02268d27aba1d58e6)
      const isAsofom =
        this.user._id === '696fe6b02268d27aba1d58e6' ||
        this.user.headOffice === '696fe6b02268d27aba1d58e6' ||
        (this.user.headOffice && this.user.headOffice._id === '696fe6b02268d27aba1d58e6') ||
        organizationId === '696fe6b02268d27aba1d58e6';
      if (
        isAsofom &&
        (this.user.role === 'HEAD_OFFICE' || this.user.role === 'ORGANIZATION' || this.user.role === 'ORGANIZATION_USER' || this.user.role === 'BRANCH')
      ) {
        nav[findIndexOfRoutes(nav, '/sac/admin')].disabled = false;
      }

      if (isAmpiFullAccess) {
        [
          '/panel-inicio',
          '/mis-eventos',
          '/miembros',
          '/capitulos',
          '/dispersiones',
          '/mis-beneficios',
          '/embedded',
          '/subgrupos',
          '/audit-logs',
          '/mis-facturas',
        ].forEach((link) => {
          const index = findIndexOfRoutes(nav, link);
          if (index !== -1) nav[index].disabled = false;
        });
      }

      // Actualizar el título si el usuario tiene el ID específico
      const capitulosIndex = findIndexOfRoutes(nav, '/capitulos');
      if (capitulosIndex !== -1) {
        nav[capitulosIndex].title = `Mis ${this.chapterOrRegionTextPlural}`;
      }

      // Productos: disponibles en dev y en producción solo para ASOFOM/Canaco León.
      if (!canAccessProductServices(this.user)) {
        nav = nav.filter((item) => item.link !== '/mis-productos');
      }
      if (!canAccessVoting(this.user)) {
        nav = nav.filter((item) => item.link !== `${votingAppUrl}/admin`);
      }

      // Ocultar módulos exclusivos de dev (Academia y SAC) fuera de dev.
      if (!this.isDevEnvironment) {
        nav = nav.filter(
          (item) =>
            (item.link !== '/mis-facturas' || isAmpiFullAccess) &&
            !item.devOnly
        );
      }

      return nav;
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),
    ...mapMutations("alert", ["showAlert"]),
    async _logout() {
      await this.logout();
    },
    async getMethodPaymentActive() {
      const response = await this.axios.get(
        Endpoints.excecuteGetMethodPayment.replace(/:userID/, this.user._id)
      );
      const methods = Array.isArray(response.data?.methods)
        ? response.data.methods
        : [];
      const bankTransferMethod = methods.find(
        (item) => item.id === "bank_transfer_payments"
      );
      this.showAlert(bankTransferMethod?.active === true);
    },
    closeLogOutDialog() {
      this.logOutDialog = true;
    },

    formatPermission(permission) {
      return `${permission.action}-${permission.subject}`;
    },
    closeMenu() {
      this.menuExpand = false;
    },

    getNav(permission) {
      let validation = {
        "create-Event": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
        ],
        "read-Membership": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
        ],
        "read-Event": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
        ],
        "read-Membership": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
        ],
        "read-Permission": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
          {
            icon: "mdi-comment-question-outline",
            title: "Mesa de ayuda",
            link: "/mesa-ayuda",
          },
          //{ icon: 'mdi-chart-bar', title: 'Estadísticas', link: 'estadistica' },
          {
            icon: "mdi-credit-card",
            title: "Mis compras",
            link: "/facturacion",
          },
          {
            icon: "mdi-chart-timeline-variant",
            title: "Dispersiones",
            link: "/dispersiones",
          },
          {
            icon: "mdi-account",
            title: "Mi cuenta",
            link: "/mi-cuenta",
            badge: true,
          },
          {
            icon: "admin_panel_settings",
            title: "Permisos",
            link: "/permisos",
          },
        ],
        "read-Payouts": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
          {
            icon: "mdi-comment-question-outline",
            title: "Mesa de ayuda",
            link: "/mesa-ayuda",
          },
          //{ icon: 'mdi-chart-bar', title: 'Estadísticas', link: 'estadistica' },
          {
            icon: "mdi-credit-card",
            title: "Mis compras",
            link: "/facturacion",
          },
          {
            icon: "mdi-chart-timeline-variant",
            title: "Dispersiones",
            link: "/dispersiones",
          },
          {
            icon: "mdi-account",
            title: "Mi cuenta",
            link: "/mi-cuenta",
            badge: true,
          },
          {
            icon: "admin_panel_settings",
            title: "Permisos",
            link: "/permisos",
          },
        ],
        "read-Purchase": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
          {
            icon: "mdi-comment-question-outline",
            title: "Mesa de ayuda",
            link: "/mesa-ayuda",
          },
          //{ icon: 'mdi-chart-bar', title: 'Estadísticas', link: 'estadistica' },
          {
            icon: "mdi-credit-card",
            title: "Mis compras",
            link: "/facturacion",
          },
          {
            icon: "mdi-chart-timeline-variant",
            title: "Dispersiones",
            link: "/dispersiones",
          },
          {
            icon: "mdi-account",
            title: "Mi cuenta",
            link: "/mi-cuenta",
            badge: true,
          },
          {
            icon: "admin_panel_settings",
            title: "Permisos",
            link: "/permisos",
          },
        ],
        "read-Transaction": [
          {
            icon: "mdi-view-dashboard",
            title: "Panel de inicio",
            link: "/panel-inicio",
          },
          {
            icon: "fa fa-calendar",
            title: "Mis eventos",
            link: "/mis-eventos",
          },
          {
            icon: "mdi-face-man-shimmer-outline",
            title: "Mis membresías",
            link: "/mis-membresias",
            disabled: true,
          },
          {
            icon: "mdi-comment-question-outline",
            title: "Mesa de ayuda",
            link: "/mesa-ayuda",
          },
          //{ icon: 'mdi-chart-bar', title: 'Estadísticas', link: 'estadistica' },
          {
            icon: "mdi-credit-card",
            title: "Mis compras",
            link: "/facturacion",
          },
          {
            icon: "mdi-chart-timeline-variant",
            title: "Dispersiones",
            link: "/dispersiones",
          },
          {
            icon: "mdi-account",
            title: "Mi cuenta",
            link: "/mi-cuenta",
            badge: true,
          },
          {
            icon: "admin_panel_settings",
            title: "Permisos",
            link: "/permisos",
          },
        ],
      };

      return validation[permission];
    },
  },
  async mounted() {
    // Validar si el usuario ya conectó su cuenta de stripe y de facturación para quitar la ayuda con las secciones que falta modificar
    if (this.$vuetify.breakpoint.mdAndUp) {
      this.sidenav = true;
    }
    if (this.user?.role === 'BRANCH') {
      try {
        const { data } = await this.axios.get('/affiliations/chapter-sales');
        this.chapterMembershipSalesEnabled =
          Array.isArray(data.affiliations) && data.affiliations.length > 0;
      } catch (_) {
        this.chapterMembershipSalesEnabled = false;
      }
    }
    if (getSpecialOrganizationPermission(this.user)) {
      this.showAlert(false);
      return;
    }
    try {
      await this.getMethodPaymentActive();
    } catch (_) {
      this.showAlert(false);
    }
  },
};
</script>
<style scoped>
.dashboard-navbar-drawer ::v-deep .v-navigation-drawer__content {
  overflow-x: hidden;
  overflow-y: auto;
}

.rounded-container {
  border-radius: 6rem !important;
}

.admin-role-label {
  display: block;
  margin-top: 4px;
  color: #6b7280;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.admin-role-label__icon {
  margin-right: 2px;
  vertical-align: text-bottom;
}

</style>
